import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Ensure the body has a data-theme from the very start so CSS variables are consistent
const initialTheme = localStorage.getItem('theme') || 'dark';
document.body.setAttribute('data-theme', initialTheme);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// No service worker in this PWA build because the app relies on dynamic
// API data fetches and cache inconsistencies are causing 404/text/html
// service-worker.js errors on Vercel.
serviceWorkerRegistration.unregister();
